import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import dayjs from 'dayjs';

import { refreshTokenThunk } from '../redux/auth/operations';
import { url } from 'components/other/terms';
import { store } from '../redux/store';

const api = axios.create({
    baseURL: url, // або url з `components/other/terms`
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
    failedQueue.forEach(prom => {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve(token);
        }
    });

    failedQueue = [];
};


api.interceptors.request.use(
    async req => {
        // const state = store.getState();
        let token = localStorage.getItem('accessToken');

        if (!token) return req;

        const decoded = jwtDecode(token);
        const isExpiredSoon = dayjs.unix(decoded.exp).diff(dayjs(), 'milliseconds') < 1000;
        console.log('DataAxios :>> ', dayjs.unix(decoded.exp).format('YYYY-MM-DDTHH:mm:ssZ[Z]'));
        if (isExpiredSoon) {
            if (!isRefreshing) {
                isRefreshing = true;
                try {
                    const action = await store.dispatch(refreshTokenThunk());

                    if (refreshTokenThunk.fulfilled.match(action)) {
                        token = action.payload.access.token;
                        localStorage.setItem('accessToken', token); // оновити локально
                        processQueue(null, token);
                    } else {
                        processQueue(action.payload || 'Refresh failed', null);
                    }
                } catch (err) {
                    processQueue(err, null);
                } finally {
                    isRefreshing = false;
                }
            }

            return new Promise((resolve, reject) => {
                failedQueue.push({
                    resolve: token => {
                        req.headers.Authorization = `Bearer ${token}`;
                        resolve(req);
                    },
                    reject: err => reject(err),
                });
            });
        }

        req.headers.Authorization = `Bearer ${token}`;
        return req;
    },
    error => Promise.reject(error)
  );

export default api;